import axios from 'axios';
import { useCookies } from 'react-cookie'
import { api } from '../../common/api'
import { ACCESS_TOKEN } from '../../common/util' 

function useChangeClubState() {
    const baseUrl = api.base_url;
    const [cookies, setCookie, removeCookie] = useCookies([ACCESS_TOKEN]);
    
    const changeClubState = async (academyId: number) => {
        try {
            const response = await axios(`${baseUrl}/academy/active/${academyId}`, {
                method: 'put',
                headers: {
                  'Content-Type':'application/json',
                  'Authorization': `Bearer ${cookies[ACCESS_TOKEN]}`,
                },
            });

            return response.status;
            
        } catch (error) {
            console.error(error);
        }
    };

    return { changeClubState };
}

export default useChangeClubState;
